import { render, staticRenderFns } from "./comment-loader.vue?vue&type=template&id=fcb25cfa&"
import script from "./comment-loader.vue?vue&type=script&lang=js&"
export * from "./comment-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports